import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.uploadStatus;

const uploadStatusData = createSelector([selector], (state) => state);

export default {
  uploadStatusData
};
